import React from 'react'
import useLocaleText from './useLocaleText'
import { ILiteral, LiteralParams } from 'utils/localeText'

interface LocaleTextProps {
  text: string | ILiteral | null | undefined
  isLocalUse?: boolean
  params?: LiteralParams
}

const LocaleText = ({ text, isLocalUse = false, params }: LocaleTextProps) => {
  const translated = useLocaleText(text, isLocalUse, params)
  return <>{translated}</>
}

export default LocaleText
